export default __webpack_public_path__ + "static/media/illustration-study-3-n-w@2x.9ad33e20.webp";